<template>
  <div class="white--text font-weight-light" style="line-height: 1rem; font-size: .75rem;">
    <slot></slot>
  </div>
</template>

<script>


export default {

};
</script>

<style></style>
